import { Injectable } from '@angular/core';
import { CentralService } from '../central.service';

@Injectable({
  providedIn: 'root'
})

export class VideoGalleryService extends CentralService {

  protected resource: string = "gallery/youtube-links";

}
